"use client";

import { atom, useAtomValue, useSetAtom } from "jotai";
import { ModalSize } from "rizzui";

type ModalTypes = {
  view: React.ReactNode;
  isOpen: boolean;
  customSize?: string;
  size?: ModalSize;
  onBackdrop?: () => void;
};

const modalAtom = atom<ModalTypes>({
  isOpen: false,
  view: null,
  customSize: "320px",
  size: "md",
  onBackdrop: undefined,
});

export function useModal() {
  const state = useAtomValue(modalAtom);
  const setState = useSetAtom(modalAtom);

  const openModal = ({
    view,
    customSize,
    size,
    onBackdrop,
  }: {
    view: React.ReactNode;
    customSize?: string;
    size?: ModalSize;
    onBackdrop?: () => void;
  }) => {
    setState({
      ...state,
      isOpen: true,
      view,
      customSize,
      size,
      onBackdrop,
    });
  };

  const closeModal = () => {
    setState({
      isOpen: false,
      view: null,
      customSize: "320px",
      size: "md",
      onBackdrop: undefined,
    });
  };

  return {
    ...state,
    openModal,
    closeModal,
  };
}
